import React from 'react';
import { useSelector } from 'react-redux';
import { formatDateTime } from '../../../utils/dateUtils';

const ViewHackathonModal = ({
  event,
  sponsors,
  firstPrize,
  secondPrize,
  otherPrizes = [],
  agendas,
  onClose
}) => {
  const mentors = useSelector((state) => state.mentors.mentors || []);
  const judges = useSelector((state) => state.judges.judges || []);


  const getNamesByRole = (data, hackathonId) =>
    data
      .filter((item) => item.hackathon_form_id === hackathonId)
      .map((item) => item.name)
      .join(', ');

  const getSponsorNames = (hackathonId) =>
    sponsors
      .filter((sponsor) => sponsor.hackathon_form_id === hackathonId)
      .map((sponsor) => sponsor.companyName)
      .join(', ');

  const mentorNames = getNamesByRole(mentors, event.id) || 'No mentors';
  const judgeNames = getNamesByRole(judges, event.id) || 'No judges';
  const sponsorNames = getSponsorNames(event.id) || 'No sponsors available';

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 overflow-auto">
      <div className="bg-color p-8 rounded-lg shadow-lg w-full max-w-2xl mx-4 mt-16 border-4 border-gray-200  border-white border-solid max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6 text-center">Hackathon Details</h2>
        <div className="flex flex-col gap-6">
          <div><strong>Event Name:</strong> {event.eventName}</div>
          <div><strong>Project Details:</strong> {event.projectDetails}</div>
          <div><strong>Technology:</strong> {event.technology}</div>
          <div><strong>Team Formation:</strong> {event.teamFormation}</div>
          <div><strong>Description:</strong> {event.description}</div>
          <div><strong>Mentors:</strong> {mentorNames}</div>
          <div><strong>Judges:</strong> {judgeNames}</div>
          <div><strong>Sponsors:</strong> {sponsorNames}</div>
          <div>
            <h3 className="text-xl font-semibold mb-2">🎁 Prizes</h3>
            <p><strong>🥇 First Prize:</strong> {firstPrize || 'N/A'}</p>
            <p><strong>🥈 Second Prize:</strong> {secondPrize || 'N/A'}</p>
            {/* {otherPrizes.length > 0 && (
              <div>
                <strong>🎁 Other Prizes:</strong>
                <ul className="list-disc list-inside ml-4">
                  {otherPrizes.map((prize, idx) => (
                    <li key={idx}>{prize}</li>
                  ))}
                </ul>
              </div>
            )} */}
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-2">🗓️ Agenda</h3>
            {agendas.length > 0 ? (
              <ul className="list-disc list-inside ml-4">
                {agendas.map((item, idx) => (
                  <li key={idx}>
                    {item.text} - {item.date ? formatDateTime(item.date) : 'Date not available'}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No agenda items available.</p>
            )}
          </div>

          <div><strong>Rules and Guidelines:</strong> {event.rulesAndGuidelines}</div>
          <div><strong>Event Platform:</strong> {event.eventPlatform}</div>
          <div><strong>Duration:</strong> {event.duration}</div>
          <div><strong>Last Registration Date:</strong> {event.lastRegistrationDate}</div>
        </div>

        <div className="mt-8 flex justify-end">
          <button
            onClick={onClose}
            className="bg-black text-white py-2 px-6 rounded-lg hover:bg-gray-800"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
};

export default ViewHackathonModal;
